import TokenomicsChart from "../components/TokenomicsChart";
import Presale from "../components/Presale";
import OurParner from "../components/OurParner";

const Home = () => {
   
    return (
        <>
            <div className="hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-7">
                            {/* Hero Content Start */}
                            <div className="hero-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h1 className="text-anime-style-2" data-cursor="-opaque">
                                        <img src="images/crypto/logo.png" width="70px" /> HyperStake AI
                                    </h1>
                                    <p className="wow fadeInUp" data-wow-delay="0.25s">
                                        HyperStake AI - Harnessing the power of artificial intelligence
                                        and advanced staking mechanisms to revolutionize decentralized
                                        finance on the Binance Smart Chain (BSC). Our cutting-edge AI
                                        algorithms analyze market trends, optimize staking strategies,
                                        and automate earnings, ensuring maximum profitability with
                                        minimal effort. By integrating smart automation and AI-driven
                                        insights, HyperStake AI empowers users to effortlessly grow
                                        their assets while contributing to a more intelligent,
                                        efficient, and sustainable DeFi ecosystem on BSC.
                                    </p>
                                </div>
                                {/* Section Title End */}
                                {/* Hero Content Body Start */}
                                <div
                                    className="hero-content-body wow fadeInUp"
                                    data-wow-delay="0.5s"
                                >
                                    <a href="#" className="btn-default mg-r-5">
                                        Stake
                                    </a>
                                    <a href="#" className="btn-default btn-highlighted">
                                        Mining App
                                    </a>
                                </div>
                                {/* Hero Content Body End */}
                                {/* <div class="hero-content-footer">
                          
                       
                        </div> */}
                            </div>
                            {/* Hero Content End */}
                        </div>
                        <div className="col-lg-5">
                            {/* Hero Image Start */}
                            <div className="hero-image">
                                {/* Hero Img Start */}
                                <div className="hero-img">
                                    <figure>
                                        <img
                                            className="wiggle-animation"
                                            src="images/crypto/logo-4.gif"
                                            alt=""
                                        />
                                    </figure>
                                </div>
                              
                            </div>
                            {/* Hero Image End */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="home-contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            {/* Contact Item Start */}
                            <div className="home-contact-item wow fadeInUp">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/profits.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Home Contact Content Start */}
                                <div className="home-contact-content">
                                    <h3>Maximize Profits</h3>
                                    <p>
                                        Our AI-driven algorithms analyze market trends to optimize your
                                        staking strategy for the highest returns.
                                    </p>
                                </div>
                                {/* Home Contact Content End */}
                            </div>
                            {/* Contact Item End */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Contact Item Start */}
                            <div
                                className="home-contact-item wow fadeInUp"
                                data-wow-delay="0.25s"
                            >
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/auto-earn.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Home Contact Content Start */}
                                <div className="home-contact-content">
                                    <h3>Automated Earnings</h3>
                                    <p>
                                        HyperStake AI automates the staking process, ensuring you earn
                                        rewards effortlessly.
                                    </p>
                                </div>
                                {/* Home Contact Content End */}
                            </div>
                            {/* Contact Item End */}
                        </div>
                        <div className="col-lg-4 col-md-6">
                            {/* Contact Item Start */}
                            <div className="home-contact-item wow fadeInUp" data-wow-delay="0.5s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/build.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Home Contact Content Start */}
                                <div className="home-contact-content">
                                    <h3>Built on Binance Smart Chain</h3>
                                    <p>
                                        Leveraging blockchain technology, we provide a fully secure and
                                        decentralized staking ecosystem.
                                    </p>
                                </div>
                                {/* Home Contact Content End */}
                            </div>
                            {/* Contact Item End */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            {/* About Image Start */}
                            <div className="about-us-image">
                                <div className="about-img">
                                    <figure className="reveal image-anime">
                                        <img src="images/crypto/banner-experience.png" alt="" />
                                    </figure>
                                    {/* Company Experience Box Start */}
                                    <div className="company-experience">
                                        <div className="icon-box">
                                            <img src="images/icon-experience.svg" alt="" />
                                        </div>
                                        <div className="company-experience-content">
                                            <h3>
                                                <span className="counter">5</span>+
                                            </h3>
                                            <p>years of experience</p>
                                        </div>
                                    </div>
                                    {/* Company Experience Box End */}
                                </div>
                            </div>
                            {/* About Image End */}
                        </div>
                        <div className="col-lg-6">
                            {/* About Us Content Start */}
                            <div className="about-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">about us</h3>
                                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                                        Revolutionizing
                                        <span> Staking</span> with
                                        <span> AI-Powered</span> Innovation
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.25s">
                                        At HyperStake AI, we are redefining the staking experience by
                                        integrating Artificial Intelligence (AI) and blockchain
                                        technology to create a more profitable, automated, and
                                        intelligent staking ecosystem. Built on the Binance Smart Chain
                                        (BSC), our platform is designed to optimize staking strategies,
                                        maximize rewards, and ensure seamless passive income generation
                                        for our users.
                                    </p>
                                </div>
                                {/* Section Title End */}
                                {/* About Us Body Start */}
                                <div className="about-us-body">
                                    {/* About List Item Start */}
                                    <div
                                        className="about-list-item wow fadeInUp"
                                        data-wow-delay="0.5s"
                                    >
                                        <div className="icon-box">
                                            <img src="images/crypto/icons/AI.png" alt="" />
                                        </div>
                                        <div className="about-list-content">
                                            <h3>AI-Driven Staking Optimization</h3>
                                        </div>
                                    </div>
                                    {/* About List Item End */}
                                    {/* About List Item Start */}
                                    <div
                                        className="about-list-item wow fadeInUp"
                                        data-wow-delay="0.5s"
                                    >
                                        <div className="icon-box">
                                            <img src="images/crypto/icons/auto-earn.png" alt="" />
                                        </div>
                                        <div className="about-list-content">
                                            <h3>Automated Earnings </h3>
                                        </div>
                                    </div>
                                    {/* About List Item End */}
                                    {/* About List Item Start */}
                                    <div
                                        className="about-list-item wow fadeInUp"
                                        data-wow-delay="0.75s"
                                    >
                                        <div className="icon-box">
                                            <img src="images/crypto/icons/community.png" alt="" />
                                        </div>
                                        <div className="about-list-content">
                                            <h3>Community-Driven Growth</h3>
                                        </div>
                                    </div>
                                    {/* About List Item End */}
                                    {/* About List Item Start */}
                                    <div
                                        className="about-list-item wow fadeInUp"
                                        data-wow-delay="0.75s"
                                    >
                                        <div className="icon-box">
                                            <img src="images/crypto/icons/security.png" alt="" />
                                        </div>
                                        <div className="about-list-content">
                                            <h3>Secure &amp; Transparent</h3>
                                        </div>
                                    </div>
                                    {/* About List Item End */}
                                </div>
                                {/* About Us Body End */}
                                {/* About Us Footer Start */}
                                <div className="about-us-footer">
                                    {/* Doctor Info Start */}
                                    <div
                                        className="doctor-info wow fadeInUp"
                                        data-wow-delay="1s"
                                    ></div>
                                    {/* Doctor Info End */}
                                    {/* Appointment Button Start */}
                                    <div className="appointment-btn wow fadeInUp" data-wow-delay="1s">
                                        <a href="#presale" className="btn-default">
                                            Join Presale
                                        </a>
                                    </div>
                                    {/* Appointment Button End */}
                                </div>
                                {/* About Us Footer End */}
                            </div>
                            {/* About Us Content End */}
                        </div>
                    </div>
                </div>
            </div>

           <OurParner />

            <div className="our-service">
                <div className="container">
                    <div className="row align-items-center section-row">
                        <div className="col-lg-7">
                            {/* Section Title Start */}
                            <div className="section-title">
                                <h3 className="wow fadeInUp">Best Services</h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    <span>We Provide</span> The Best Services
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            {/* Service Item Start */}
                            <div className="service-item wow fadeInUp">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/staking.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Service Body Start */}
                                <div className="service-body">
                                    <h3>Staking </h3>
                                    <p>Earn passive income with AI-optimized staking on BSC.</p>
                                </div>
                                {/* Service Body End */}
                                {/* Service Footer Start */}
                                <div className="service-footer">
                                    <small className="text-coming-soon">Coming soon</small>
                                </div>
                                {/* Service Footer End */}
                            </div>
                            {/* Service Item End */}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            {/* Service Item Start */}
                            <div className="service-item wow fadeInUp" data-wow-delay="0.2s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/mining.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Service Body Start */}
                                <div className="service-body">
                                    <h3>Mining</h3>
                                    <p>
                                        Engage in decentralized mining and earn rewards effortlessly
                                    </p>
                                </div>
                                {/* Service Body End */}
                                {/* Service Footer Start */}
                                <div className="service-footer">
                                    <small className="text-coming-soon">Coming soon</small>
                                </div>
                                {/* Service Footer End */}
                            </div>
                            {/* Service Item End */}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            {/* Service Item Start */}
                            <div className="service-item wow fadeInUp" data-wow-delay="0.4s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/chatbot.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Service Body Start */}
                                <div className="service-body">
                                    <h3>AI chatbot</h3>
                                    <p>
                                        Get real-time insights, market analysis, and AI-powered support
                                    </p>
                                </div>
                                {/* Service Body End */}
                                {/* Service Footer Start */}
                                <div className="service-footer">
                                    <small className="text-coming-soon">Coming soon</small>
                                </div>
                                {/* Service Footer End */}
                            </div>
                            {/* Service Item End */}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            {/* Service Item Start */}
                            <div className="service-item wow fadeInUp" data-wow-delay="0.6s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/ai-onchain.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Service Body Start */}
                                <div className="service-body">
                                    <h3>AI Onchain Analyst</h3>
                                    <p>
                                        Analyze blockchain data for trends, risks, and smarter
                                        investments
                                    </p>
                                </div>
                                {/* Service Body End */}
                                {/* Service Footer Start */}
                                <div className="service-footer">
                                    <small className="text-coming-soon">Coming soon</small>
                                </div>
                                {/* Service Footer End */}
                            </div>
                            {/* Service Item End */}
                        </div>
                        <div className="col-lg-3 col-md-6">
                            {/* Service Item Start */}
                            <div className="service-item wow fadeInUp" data-wow-delay="0.8s">
                                {/* Icon Box Start */}
                                <div className="icon-box">
                                    <img src="images/crypto/icons/ai-agent.png" alt="" />
                                </div>
                                {/* Icon Box End */}
                                {/* Service Body Start */}
                                <div className="service-body">
                                    <h3>AI Agent</h3>
                                    <p>
                                        Automate staking, trading, and DeFi strategies with AI
                                        intelligence
                                    </p>
                                </div>
                                {/* Service Body End */}
                                {/* Service Footer Start */}
                                <div className="service-footer">
                                    <small className="text-coming-soon">Coming soon</small>
                                </div>
                                {/* Service Footer End */}
                            </div>
                            {/* Service Item End */}
                        </div>
                    </div>
                </div>
            </div>

            <TokenomicsChart />

            <div className="therapy-process">
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h3
                                    className="wow fadeInUp"
                                    style={{ visibility: "visible", animationName: "fadeInUp" }}
                                >
                                    Roadmap
                                </h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    <span>Roadmap</span> shapes the future
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="therapy-process-item wow fadeInUp"
                                style={{ visibility: "visible", animationName: "fadeInUp" }}
                            >
                                <div className="icon-box">
                                    <figure className="image-anime">
                                        <img src="images/crypto/roadmap/staking.png" alt="" />
                                    </figure>
                                </div>
                                <div className="therapy-process-content">
                                    <h3>🔷 Phase 1: Staking (Q2/2025)</h3>
                                    <p>🟩 Launch decentralized staking on BSC</p>
                                    <p>🟩 Enable users to earn passive income</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="therapy-process-item wow fadeInUp"
                                data-wow-delay="0.25s"
                                style={{
                                    visibility: "visible",
                                    animationDelay: "0.25s",
                                    animationName: "fadeInUp"
                                }}
                            >
                                <div className="icon-box">
                                    <figure className="image-anime">
                                        <img src="images/crypto/roadmap/mining.png" alt="" />
                                    </figure>
                                </div>
                                <div className="therapy-process-content">
                                    <h3>🔷 Phase 2: Mining App (Q2/2025)</h3>
                                    <p>🟩 Introduce a mobile &amp; web-based mining application</p>
                                    <p>🟩 Reward users through engagement-based mining mechanisms</p>
                                    <p>🟩 Implement AI-driven dynamic reward adjustments</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="therapy-process-item wow fadeInUp"
                                data-wow-delay="0.5s"
                                style={{
                                    visibility: "visible",
                                    animationDelay: "0.5s",
                                    animationName: "fadeInUp"
                                }}
                            >
                                <div className="icon-box">
                                    <figure className="image-anime">
                                        <img src="images/crypto/roadmap/AI.png" alt="" />
                                    </figure>
                                </div>
                                <div className="therapy-process-content">
                                    <h3>🔷 Phase 3: AI+ (Q3/2025)</h3>
                                    <p>
                                        🟩 AI Chatbot - A smart assistant for staking, mining, and user
                                        support
                                    </p>
                                    <p>
                                        🟩 AI Analyst Onchain - Real-time blockchain data analysis to
                                        detect trends and risks.
                                    </p>
                                    <p>
                                        🟩 AI Agent - Fully autonomous AI-driven decision-making for
                                        DeFi optimization{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="therapy-process-item wow fadeInUp"
                                data-wow-delay="0.75s"
                                style={{
                                    visibility: "visible",
                                    animationDelay: "0.75s",
                                    animationName: "fadeInUp"
                                }}
                            >
                                <div className="icon-box">
                                    <figure className="image-anime">
                                        <img src="images/crypto/roadmap/listing.png" alt="" />
                                    </figure>
                                </div>
                                <div className="therapy-process-content">
                                    <h3>🔷 Phase 4: Listing (Q4/2025)</h3>
                                    <p>🟩 Listing on DEX PancakeSwap - BSC network </p>
                                    <p>🟩 Listing on CGC and CMC </p>
                                    <p>🟩 Listing on CEX </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <Presale />
        </>
    )
}

export default Home;